import { isEqual, sortBy } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import {
  setActiveCourseNames as setCourseNames,
  setCurrentTeamCourseIds as setCurrentTeamCourses,
} from '../ducks/features/teamsSlice';
import { RootState } from '../ducks/store';

interface IUseGetTeamsSlice {
  currentTeamCourseIds: string[]; // Current list of course ids for the selected teams
  activeCourses: string[];
  activeCourseNames?: string[];
  noCoursesSelected: boolean;
  setCurrentTeamCourseIds: (teamCourseIds: string[]) => void;
  setActiveCourseNames: (courseNames: string[]) => void;
}

// TODO: Maybe move useActiveTeams, useGetCourseNames, and useActiveDeselectedCourses to this hook in the future
export const useGetTeamsSlice = (): IUseGetTeamsSlice => {
  // ===========================================================================
  // Redux
  // ===========================================================================

  const dispatch = useDispatch();

  const { currentTeamCourseIds, activeDeselectedCourses } = useSelector(
    (state: RootState) => state.teamsSlice,
  );

  // ===========================================================================
  // Other
  // ===========================================================================

  const noCoursesSelected = currentTeamCourseIds.every((courseId) =>
    activeDeselectedCourses.includes(courseId),
  );

  const activeCourses = currentTeamCourseIds.filter(
    (courseId) => !activeDeselectedCourses.includes(courseId),
  );

  // ===========================================================================
  // Functions
  // ===========================================================================

  const setCurrentTeamCourseIds = (teamCourseIds: string[]) => {
    dispatch(setCurrentTeamCourses(teamCourseIds));
  };

  const setActiveCourseNames = (courseNames: string[]) => dispatch(setCourseNames(courseNames));

  return {
    currentTeamCourseIds,
    activeCourses,
    noCoursesSelected,
    setCurrentTeamCourseIds,
    setActiveCourseNames,
  };
};
